import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { TabsContext } from "../Tabs/TabsContext";
import { getTabId, getPanelId } from "../Tabs/get-accessibility-ids";
import { DURATION } from "../../hooks/useFlip/flip-constants";
import { useLazyLoad } from "../Tabs/useLazyLoad";
import { validChildren } from "../../utils/valid-children";
export function Pager(_ref) {
  var _ref$lazyLoad = _ref.lazyLoad,
      lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
      children = _ref.children,
      _ref$currentPage = _ref.currentPage,
      currentPageProp = _ref$currentPage === void 0 ? 0 : _ref$currentPage,
      other = _objectWithoutProperties(_ref, ["lazyLoad", "children", "currentPage"]); // Pagers can be used within Tabs. If so, let's access the tab
  // context and apply the necessary accessibility attributes.
  // It might be wise to eventually provide a unique TabsPager
  // component here to avoid mixing context in like this.


  var _useContext = useContext(TabsContext),
      id = _useContext.id,
      value = _useContext.value; // If used outside of `Tabs` treat Pager as a controlled component


  var currentPage = value == null ? currentPageProp : value;

  var _useLazyLoad = useLazyLoad({
    lazyLoad: lazyLoad,
    itemCount: validChildren(children).length,
    currentPage: currentPage
  }),
      shouldLoadIndex = _useLazyLoad.shouldLoadIndex;

  return /*#__PURE__*/React.createElement(PagerContainer, other, /*#__PURE__*/React.createElement(PagerAnimatedContainer, {
    transition: {
      duration: DURATION / 1000
    },
    initial: false,
    animate: {
      x: "".concat(currentPage * -100, "%")
    }
  }, React.Children.map(children, function (child, i) {
    var load = shouldLoadIndex(i);
    return /*#__PURE__*/React.createElement(Page, {
      key: i,
      role: "tabpanel",
      "aria-labelledby": id ? getTabId(id, i) : undefined,
      id: id ? getPanelId(id, i) : undefined,
      "aria-hidden": currentPage !== i,
      tabIndex: currentPage === i ? 0 : -1
    }, load && child);
  })));
}
var PagerContainer = styled.div.withConfig({
  displayName: "Pager__PagerContainer",
  componentId: "vapor__sc-2dyp6c-0"
})(["display:flex;flex-direction:column;overflow:hidden;width:100%;height:100%;"]);
var PagerAnimatedContainer = styled(motion.div).withConfig({
  displayName: "Pager__PagerAnimatedContainer",
  componentId: "vapor__sc-2dyp6c-1"
})(["flex-direction:row;direction:ltr;min-height:0;flex:1;display:flex;will-change:transform;"]);
var Page = styled.div.withConfig({
  displayName: "Pager__Page",
  componentId: "vapor__sc-2dyp6c-2"
})(["display:flex;flex-direction:column;width:100%;align-self:stretch;justify-content:flex-start;flex-shrink:0;height:100%;outline:none;"]);